import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCzVJJa7ijEGturxOavXgiyT0ePJ3XmIn0",
    authDomain: "okinawan-corpus.firebaseapp.com",
    projectId: "okinawan-corpus",
    storageBucket: "okinawan-corpus.appspot.com",
    messagingSenderId: "59439154539",
    appId: "1:59439154539:web:aa573e56b2166c3b91382e",
    measurementId: "G-L80NF30KM3"
}

// init firebase
const app = initializeApp(firebaseConfig)

// init services
const analytics = getAnalytics(app)
const db = getFirestore(app)

export { db, analytics }